import styled from 'styled-components';
import { ICON_CONTAINER_WIDTH, LOGOTYPE_PADDING, LIST_GAP } from '../config.js';
import { SidebarMenuItemContainer } from '../SidebarMenuItem/styled.js';
import { pxToRem } from '../../../foundation/spacing/utils.js';
import { themeGet } from '../../../foundation/theme/themeGet/get.js';

var SidebarMenuCollapsibleItemContainer = styled(SidebarMenuItemContainer).withConfig({
  displayName: "SidebarMenuCollapsibleItemContainer",
  componentId: "sc-1vj0za4-0"
})(["min-height:", ";margin-left:", ";padding:0 ", ";", " &:after{content:'';position:absolute;top:0;right:calc(100% + ", " / 2);width:", ";height:calc(100% + ", ");background-color:", ";}&:first-of-type:not(:last-of-type):after{height:75%;top:50%;}&:last-of-type:not(:first-of-type):after{height:75%;top:-25%;}&:first-of-type:last-of-type:after{height:20%;top:40%;}"], ICON_CONTAINER_WIDTH, ICON_CONTAINER_WIDTH, LOGOTYPE_PADDING, function (props) {
  return props.$isMenuChild && "\n    width: 100%;\n    margin-left: 0;\n    padding-right: " + pxToRem(32) + ";\n  ";
}, ICON_CONTAINER_WIDTH, pxToRem(2), LIST_GAP, themeGet('colors.gray.100'));

export { SidebarMenuCollapsibleItemContainer };
